import { NylasListConnectionsResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * /integrations/nylas/connections/list is the Smithy-canonical route;
 * /oauth/connections is a legacy alias also wired to the same backend
 * `listConnections` handler. Both return the envelope shape
 * `{ connected, connections: NylasConnection[] }`.
 *
 * Disabled rows (enabled=false) are filtered here. The backend returns
 * every row that hasn't been hard-deleted — including rows where the
 * Nylas grant was revoked (nylas-reauth-activity flips enabled=false)
 * or the cached grant 404s on the lazy-fetch (oauth.ts:452 marks the
 * row stale). Downstream consumers (useIntegrationConnections) derive
 * "connected" status from provider + scopes and would otherwise treat
 * a revoked row as live.
 */
export const listIntegrationConnectionsApi = async (): Promise<NylasListConnectionsResponseContent> => {
  const apiRequest = createApiRequest<NylasListConnectionsResponseContent>('post', '/integrations/nylas/connections/list');
  const response = await apiRequest({});
  const connections = (response.connections ?? []).filter(c => c.enabled);
  return {
    connected: connections.length > 0,
    connections,
  };
};
